import classNames from "classnames"
import Image from "next/image"

import { Paragraph1 } from "@bounce/design-system"

import type StepCompact from "@/components/LuggageStorage/HowItWorks/HowItWorksCompact/types"

type HowItWorksStepsCompactProps = {
  steps: StepCompact[]
  className?: string
}

export const HowItWorksStepsCompact = ({ className, steps }: HowItWorksStepsCompactProps) => {
  return (
    <div className={classNames(className, "grid w-full grid-cols-1 gap-x-6 gap-y-8 xl:grid-flow-col xl:grid-cols-3")}>
      {steps.map(({ src, title, description }, index) => (
        <section key={index} className="flex flex-col">
          <Image src={src} height={78} width={78} alt="" key={index} />
          <div className="mt-5">
            <p className="title5 break-words">{title}</p>
            <Paragraph1 className="mt-2 text-neutral-800">{description}</Paragraph1>
          </div>
        </section>
      ))}
    </div>
  )
}
